import { cn } from '@/lib/utils';
import React, { ReactNode, useCallback } from 'react';
import HighlightText from './highlight-text';


type TextTileProps = {
    title: string;
    children: ReactNode;
    newLines?: boolean;
    className?: string;
}

const TextTile: React.FC<TextTileProps> = React.memo(({ title, children, className, newLines = false }) => {

    const renderContent = useCallback(() => {
        // Always wrap children with HighlightText
        return <HighlightText>{children}</HighlightText>;
    }, [children]);

    return (
        <div className={cn("flex flex-col gap-0.5 break-inside-avoid",
            // Apply whitespace-pre-wrap if newLines is true, otherwise normal
            newLines ? 'whitespace-pre-wrap' : 'whitespace-normal',
            className
        )}>
            <div className="text-xs text-zinc-400 font-light break-before-avoid">
                {title}
            </div>
            <div className="text-sm text-zinc-950">
                {/* Directly render the content; whitespace handled by parent div's class */}
                {renderContent()}
            </div>
        </div>
    );
});

export default TextTile;